import { render, staticRenderFns } from "./FooterSign.vue?vue&type=template&id=4a741aac"
import script from "./FooterSign.vue?vue&type=script&lang=js"
export * from "./FooterSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports